import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { NvDesignLibraryModule } from '../../../../../nvps-libraries/design/nv-design-library.module';
import { NvMatTooltipModule } from '../../nv-mat-tooltip/nv-mat-tooltip.module';
import { AssessmentsSettingsComponent } from './assessments-settings.component';

@NgModule({
  imports: [CommonModule, MatMenuModule, NvDesignLibraryModule, NvMatTooltipModule],
  declarations: [AssessmentsSettingsComponent],
  exports: [AssessmentsSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AssessmentsSettingsModule {}
